// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"b9580014","312":"808d1af6","375":"548c6a8c","403":"3007fd07","484":"94a06cad","638":"07bed7c5","842":"37274922","869":"ae3d355a","974":"ea2b632d"}[chunkId] + ".chunk.js";
};